/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDrugRegisterAmendmentCommand } from '../models/CreateDrugRegisterAmendmentCommand';
import type { DrugRegisterAmendmentDtoResponse } from '../models/DrugRegisterAmendmentDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugRegisterAmendmentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns DrugRegisterAmendmentDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugRegisterAmendmentsCreateAmendment(
        requestBody?: CreateDrugRegisterAmendmentCommand,
    ): CancelablePromise<DrugRegisterAmendmentDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugRegisterAmendments/CreateAmendment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
